import { AutocompleteProps } from '@elipssolution/harfang';
import { FieldPath, FieldValues, RegisterOptions } from 'react-hook-form';

export enum FormFieldEnum {
	AUTOCOMPLETE = 'autocomplete',
	TEXTFIELD = 'textfield',
	IMAGE = 'image',
}

export type DefaultFormType = {
	name: string;
	isExternal: boolean;
	isInternal: boolean;
	isAvailableOnDesktopFormat?: boolean;
	isAvailableOnMobileFormat?: boolean;
} & { [key: string]: unknown };

type ValidationRules = Omit<
	RegisterOptions<FieldValues, FieldPath<FieldValues>>,
	'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'
>;

type CommonFieldInfos = {
	key: string;
	type: FormFieldEnum;
	description: string;
	label: string;
};

export type TextFieldType = CommonFieldInfos & {
	type: FormFieldEnum.TEXTFIELD;
	name: string;
	rules?: ValidationRules;
	value?: string;
};

export type AutocompleteFieldType<T> = CommonFieldInfos & {
	type: FormFieldEnum.AUTOCOMPLETE;
	name: string;
	value?: AutocompleteProps<T, false>['value'];
	getOptionLabel?: AutocompleteProps<T, false>['getOptionLabel'];
	dataSource: AutocompleteProps<T, false>['dataSource'];
	disableClearable?: AutocompleteProps<T, false>['disableClearable'];
	rules?: ValidationRules;
};

export type ImageFieldType = CommonFieldInfos & {
	name: string;
	type: FormFieldEnum.IMAGE;
	onChange: (file: File) => void;
	value?: File;
};

export type SpecificFieldsType = TextFieldType | AutocompleteFieldType<unknown> | ImageFieldType;
